import { CheckCircle } from '@mui/icons-material';
import { AppBar, Box, Button, Container, Divider, Grid, Toolbar, Typography } from '@mui/material';
import i18next from 'i18next';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Moment from 'react-moment';
import { withRouter } from 'react-router-dom';
import api from '../../api';
import PaymentMethodEnum from '../../enums/PaymentMethodEnum';
import CurrencyDisplay from '../common/CurrencyDisplay';
import Header from '../common/Header';
import Progress from '../common/Progress';

@inject('commonStore', 'cartStore', 'orderStore', 'menuStore')
@observer
class OrderComplete extends Component {
  state = {
    isLiteOrder: false,
  };

  async componentDidMount() {
    const { commonStore, cartStore, orderStore, menuStore, match } = this.props;
    // 장바구니 비우기
    cartStore.clearCart();

    // 매장 데이터 세팅
    await commonStore.setData(match.params.companyId.toLowerCase(), match.params.storeCode);

    // 주문 조회 및 세팅
    const response = await api.getSale(
      match.params.companyId,
      match.params.storeCode,
      match.params.orderId,
      i18next.languages[0],
    );
    orderStore.setOrder(response.data);
    // 현재 조회 된 상점 데이터가 없거나 (카톡 링크로 접속한 경우)
    // 조회한 주문의 상점과 현재 상점이 다른 경우
    // 매장 데이터 다시 조회
    if (
      !menuStore.storeData ||
      orderStore.order.companyId !== menuStore.storeData.companyId ||
      orderStore.order.storeCode !== menuStore.storeData.storeCode
    ) {
      commonStore.setData(orderStore.order.companyId, orderStore.order.storeCode);
    }
    this.setState(() => ({ isLiteOrder: this.props.orderStore.order.extOrderNo }));
  }

  handleClickOrderDetail = () => {
    const { history, location, match } = this.props;
    if (this.state.isLiteOrder) {
      // 새로고침 일때 버튼 유지를 위해 다른 URL 적용
      history.push(
        `/${match.params.companyId}/${match.params.storeCode}/lite-orders/${match.params.orderId}${location.search}`,
      );
    } else {
      history.push(
        `/${match.params.companyId}/${match.params.storeCode}/orders/${match.params.orderId}${location.search}`,
      );
    }
  };

  handleClickConfirm = () => {
    const { commonStore, history, location } = this.props;
    history.push(`/${commonStore.companyId}/${commonStore.storeCode}${location.search}`);
  };

  render() {
    const { orderStore, menuStore, t } = this.props;
    if (!menuStore.storeData || !orderStore.order) return <Progress />;
    return (
      <React.Fragment>
        {/* 헤더 */}
        <Header iconType="CART" title={t('order.title.completed')} />

        <Box
          sx={{ background: theme => `linear-gradient(${theme.palette.primary.main} 210px, #fff 0%)` }}
          className="contents"
        >
          <Container style={{ backgroundColor: '#fff', padding: '20px', border: '1px solid #DDD' }}>
            <div style={{ paddingBottom: '30px' }}>
              <Grid container direction="column" alignItems="center" spacing={3}>
                <Grid item xs>
                  <CheckCircle color="primary" style={{ fontSize: '60px' }} />
                </Grid>
                <Grid item xs>
                  <Typography align="center" style={{ fontSize: '17pt', fontWeight: '500' }}>
                    {t('payment.label.completed')}
                  </Typography>
                </Grid>
              </Grid>
            </div>
            <Divider style={{ borderTop: 'dotted 1px #D9D9D9' }} />

            <div style={{ padding: '45px 0' }}>
              <Grid container spacing={2}>
                <Grid item container direction="row">
                  <Grid item>
                    <b>{t('order.label.orderNumber')}</b>
                  </Grid>
                  <Grid item xs>
                    <Typography align="right">{orderStore.order.waitNum}</Typography>
                  </Grid>
                </Grid>
                <Grid item container direction="row">
                  <Grid item>
                    <b>{t('shop.label.name')}</b>
                  </Grid>
                  <Grid item xs>
                    <Typography align="right">{orderStore.order.storeName}</Typography>
                  </Grid>
                </Grid>
                <Grid item container direction="row">
                  <Grid item>
                    <b>{t('payment.label.amount')}</b>
                  </Grid>
                  <Grid item xs style={{ textAlign: 'right' }}>
                    <CurrencyDisplay amount={Number(orderStore.order.finalAmount)} type="emphasis" />
                  </Grid>
                </Grid>
                <Grid item container direction="row">
                  <Grid item>
                    <b>{t('payment.label.method')}</b>
                  </Grid>
                  <Grid item xs>
                    <Typography align="right">{orderStore.paymentMethodName}</Typography>
                  </Grid>
                </Grid>
                {orderStore.order.payments.length === 1 &&
                  orderStore.order.payments[0].methodCode === PaymentMethodEnum.CARD && (
                    <React.Fragment>
                      {orderStore.order.payments[0].cardQuota > 0 && (
                        <Grid item container direction="row">
                          <Grid item>
                            <b>{t('payment.label.installment')}</b>
                          </Grid>
                          <Grid item xs>
                            <Typography align="right">
                              {+orderStore.order.payments[0].cardQuota === 1
                                ? t('payment.label.fullPayment')
                                : t('payment.label.installmentMonths', { n: +orderStore.order.payments[0].cardQuota })}
                            </Typography>
                          </Grid>
                        </Grid>
                      )}
                      {orderStore.order.payments[0].authCode && (
                        <Grid item container direction="row">
                          <Grid item>
                            <b>{t('payment.label.approvalNumber')}</b>
                          </Grid>
                          <Grid item xs>
                            <Typography align="right">{orderStore.order.payments[0].authCode}</Typography>
                          </Grid>
                        </Grid>
                      )}
                      {orderStore.order.payments[0].authDate && (
                        <Grid item container direction="row">
                          <Grid item>
                            <b>{t('payment.label.approvalDate')}</b>
                          </Grid>
                          <Grid item xs>
                            <Typography align="right">
                              <Moment
                                parse={
                                  orderStore.order.payments[0].authDate.length === 12
                                    ? 'YYMMDDHHmmss'
                                    : 'YYYYMMDDHHmmss'
                                }
                                format="YYYY-MM-DD HH:mm:ss"
                              >
                                {orderStore.order.payments[0].authDate}
                              </Moment>
                            </Typography>
                          </Grid>
                        </Grid>
                      )}
                    </React.Fragment>
                  )}
              </Grid>
            </div>

            <Divider style={{ borderTop: 'dotted 1px #D9D9D9' }} />

            <div style={{ paddingTop: '30px' }}>
              <Grid container alignItems="center">
                <Grid item xs></Grid>
                <Grid item xs={8} md={6} lg={4}>
                  <Button
                    variant="contained"
                    size="large"
                    fullWidth
                    style={{ backgroundColor: '#929495', color: '#fff' }}
                    onClick={this.handleClickOrderDetail}
                  >
                    {t('order.button.viewDetail')}
                  </Button>
                </Grid>
                <Grid item xs></Grid>
              </Grid>
            </div>
          </Container>
        </Box>
        {!this.state.isLiteOrder && (
          <AppBar position="fixed" color="primary" className="bottom">
            <Toolbar>
              <Button fullWidth color={'inherit'} onClick={this.handleClickConfirm}>
                <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{t('order.button.finish')}</span>
              </Button>
            </Toolbar>
          </AppBar>
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(withTranslation()(OrderComplete));
